import dayjs from "dayjs";

export function getPoiTimeInfo(isoString?: string): string {
  if (!isoString) return "";
  const m = dayjs(isoString);
  if (m.isSame(dayjs(), "day")) {
    return `Today, ${m.format("h:mm A")}`;
  }
  return m.format("YYYY-MM-DD, h:mm A");
}

// export function getPoiTimeInfo(isoString?: string): string {
//   if (!isoString) return "";
//   const m = moment(isoString);
//   if (m.isSame(moment(), "day")) {
//     return `Today, ${m.format("h:mm A")}`;
//   }
//   return m.format("YYYY-MM-DD, h:mm A");
// }